import { getHeaders, ICreateGraphParams, userStore, withRetry } from "@root/common"

type TGetSpreadInfo = ICreateGraphParams & { timeFrame: number }
export async function getSpreadInfo({ type, coin, long, short, timeFrame }: TGetSpreadInfo) {
    const baseUrl = await userStore.getBaseUrl()
    const response = await withRetry(async () => await fetch(`${baseUrl}/spread-info`, {
        headers: await getHeaders(),
        method: "POST",
        body: JSON.stringify({type, coin, long: type === 'margin' ? short : long, short: type === 'margin' ? long : short, timeFrame}),
    }))
    const json = await response.json()

    return json
}


